export default __webpack_public_path__ + "static/media/planning.55ccfd48.svg";